import React from "react";
import { Link } from "react-router-dom";
import { StyleSheet, css } from "aphrodite";
export default function MiniNavBar({click}){

    const styles = StyleSheet.create({
        linksContainerStyle: {
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            backgroundColor: '#F0EFEC',
            top: '80px',
            left:'0',
            gap: '10px',
            width:'100%'
            
        },
        linkItem: {
            fontFamily: "Oswald",
            fontSize:'1.2rem',
            fontStyle: "300",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            height:'auto',
            color: '#011a39',
            cursor:'pointer',
            transition: '.3s all',
            
        }
        })
    return(
        <>
            <div className={css(styles.linksContainerStyle)}>
                <Link onClick={()=>click(false)} className={css(styles.linkItem)} to="/">HOME</Link>
                <Link onClick={()=>click(false)} className={css(styles.linkItem)} to="/products">PRODUCTS</Link>
                <Link onClick={()=>click(false)} className={css(styles.linkItem)} to="/about-us">ABOUT US</Link>
                <Link onClick={()=>click(false)} className={css(styles.linkItem)} to="/support">SUPPORT</Link>
            </div> 
        </>
    )
}